/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BudgetSummaryResponse } from './BudgetSummaryResponse';
import {
    BudgetSummaryResponseFromJSON,
    BudgetSummaryResponseFromJSONTyped,
    BudgetSummaryResponseToJSON,
    BudgetSummaryResponseToJSONTyped,
} from './BudgetSummaryResponse';
import type { RemediationSummaryResponse } from './RemediationSummaryResponse';
import {
    RemediationSummaryResponseFromJSON,
    RemediationSummaryResponseFromJSONTyped,
    RemediationSummaryResponseToJSON,
    RemediationSummaryResponseToJSONTyped,
} from './RemediationSummaryResponse';
import type { FunctionMaturityItem } from './FunctionMaturityItem';
import {
    FunctionMaturityItemFromJSON,
    FunctionMaturityItemFromJSONTyped,
    FunctionMaturityItemToJSON,
    FunctionMaturityItemToJSONTyped,
} from './FunctionMaturityItem';
import type { RecentActivityItem } from './RecentActivityItem';
import {
    RecentActivityItemFromJSON,
    RecentActivityItemFromJSONTyped,
    RecentActivityItemToJSON,
    RecentActivityItemToJSONTyped,
} from './RecentActivityItem';

/**
 * 
 * @export
 * @interface DashboardResponse
 */
export interface DashboardResponse {
    /**
     * 
     * @type {Array<FunctionMaturityItem>}
     * @memberof DashboardResponse
     */
    functionMaturity?: Array<FunctionMaturityItem>;
    /**
     * 
     * @type {number}
     * @memberof DashboardResponse
     */
    overallMaturity?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardResponse
     */
    assessmentProgressPercent?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardResponse
     */
    findingsSatisfied?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardResponse
     */
    findingsNotSatisfied?: number;
    /**
     * 
     * @type {RemediationSummaryResponse}
     * @memberof DashboardResponse
     */
    remediationSummary?: RemediationSummaryResponse;
    /**
     * 
     * @type {BudgetSummaryResponse}
     * @memberof DashboardResponse
     */
    budgetSummary?: BudgetSummaryResponse;
    /**
     * 
     * @type {Array<RecentActivityItem>}
     * @memberof DashboardResponse
     */
    recentActivity?: Array<RecentActivityItem>;
}

/**
 * Check if a given object implements the DashboardResponse interface.
 */
export function instanceOfDashboardResponse(value: object): value is DashboardResponse {
    return true;
}

export function DashboardResponseFromJSON(json: any): DashboardResponse {
    return DashboardResponseFromJSONTyped(json, false);
}

export function DashboardResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'functionMaturity': json['functionMaturity'] == null ? undefined : ((json['functionMaturity'] as Array<any>).map(FunctionMaturityItemFromJSON)),
        'overallMaturity': json['overallMaturity'] == null ? undefined : json['overallMaturity'],
        'assessmentProgressPercent': json['assessmentProgressPercent'] == null ? undefined : json['assessmentProgressPercent'],
        'findingsSatisfied': json['findingsSatisfied'] == null ? undefined : json['findingsSatisfied'],
        'findingsNotSatisfied': json['findingsNotSatisfied'] == null ? undefined : json['findingsNotSatisfied'],
        'remediationSummary': json['remediationSummary'] == null ? undefined : RemediationSummaryResponseFromJSON(json['remediationSummary']),
        'budgetSummary': json['budgetSummary'] == null ? undefined : BudgetSummaryResponseFromJSON(json['budgetSummary']),
        'recentActivity': json['recentActivity'] == null ? undefined : ((json['recentActivity'] as Array<any>).map(RecentActivityItemFromJSON)),
    };
}

export function DashboardResponseToJSON(json: any): DashboardResponse {
    return DashboardResponseToJSONTyped(json, false);
}

export function DashboardResponseToJSONTyped(value?: DashboardResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'functionMaturity': value['functionMaturity'] == null ? undefined : ((value['functionMaturity'] as Array<any>).map(FunctionMaturityItemToJSON)),
        'overallMaturity': value['overallMaturity'],
        'assessmentProgressPercent': value['assessmentProgressPercent'],
        'findingsSatisfied': value['findingsSatisfied'],
        'findingsNotSatisfied': value['findingsNotSatisfied'],
        'remediationSummary': RemediationSummaryResponseToJSON(value['remediationSummary']),
        'budgetSummary': BudgetSummaryResponseToJSON(value['budgetSummary']),
        'recentActivity': value['recentActivity'] == null ? undefined : ((value['recentActivity'] as Array<any>).map(RecentActivityItemToJSON)),
    };
}

